import axios from "axios";
import React, { useState, useRef } from "react";
// importo .env
import { Modal } from "react-bootstrap";
import { env } from "../../env/env";
import toast, { Toaster } from "react-hot-toast";
import logo from "../Login/logo.png";
const API_ENDPOINT = `${ env.API_ENDPOINT }/logindecrypt`;

const Login = () => {
  const user = useRef();
  const pass = useRef();

  const verificar = async () => {
    await axios
      .post( API_ENDPOINT, {
        usuario: user.current.value,
        password: pass.current.value,
        ip: '181.113.59.4'
      } )
      .then( function ( response ) {
        // handle success

        if ( response.data === "UNE" ) {
          toast.error( "El usuario ingresado no existe! Por favor Cree una cuenta nueva" );
        }
        if ( response.data === "UI" ) {
          toast.error( "Usuario Inactivo!" );
        }
        if ( response.data === "PI" ) {
          toast.error( "Contraseña Incorrecta! Por favor dar clic en: Olvidó su contraseña? " );
        }
        if (
          response.data !== "UNE" &&
          response.data !== "UI" &&
          response.data !== "PI"
        ) {
          sessionStorage.setItem( "usuario", response.data[ 0 ].cli_cedula );
          sessionStorage.setItem( "cedula", response.data[ 0 ].cli_cedula );

          window.location = "/dashboard";
        }
      } )
      .catch( function ( error ) {
        // handle error
        //  console.log(error);
        toast.error( " Ha ocurrido un error!" );
      } );
  };

  const handleKeyPress = async ( event ) => {
    if ( event.key === "Enter" ) {
      await verificar();
    }
  };

  const cli_cedula = useRef();
  const cli_email = useRef();
  const recuperar = async ( event ) => {
    await axios
      .post( `${ env.API_ENDPOINT }/recuperar`, {
        cli_cedula: cli_cedula.current.value,
        cli_email: cli_email.current.value,
      } )
      .then( async function ( response ) {
        // handle success
        if ( response.data === "ok" ) {
          toast.success( 'Por favor, revisa tu correo electrónico, ingresa con tu contraseña temporal' );
          await setisOpenOlvido( false );
        }
      } )
      .catch( function ( error ) {
        // handle error
        //  console.log(error);
        toast.error( " Ha ocurrido un error!" );
      } );
  };

  const [ isOpenOlvido, setisOpenOlvido ] = useState( false );
  const [ isOpenCrear, setisOpenCrear ] = useState( false );

  const cli_cedula_reg = useRef();
  const cli_password = useRef();
  const cli_email_reg = useRef();
  const cli_direccion = useRef();
  const cli_telefono = useRef();
  const cli_tipo_persona = useRef();
  const cli_nombres = useRef();
  const cli_apellidos = useRef();

  const crearcuenta = async () => {

    if (
      cli_cedula_reg.current.value !== "" &&
      cli_password.current.value !== "" &&
      cli_email_reg.current.value !== "" &&
      cli_direccion.current.value !== "" &&
      cli_telefono.current.value !== "" &&
      cli_tipo_persona.current.value !== "" &&
      cli_nombres.current.value !== "" &&
      cli_apellidos.current.value !== ""
    ) {
      await axios
        .post( `${ env.API_ENDPOINT }/crearusuario`, {
          cli_cedula: cli_cedula_reg.current.value,
          cli_password: cli_password.current.value,
          cli_email: cli_email_reg.current.value,
          cli_direccion: cli_direccion.current.value,
          cli_telefono: cli_telefono.current.value,
          cli_tipo_persona: cli_tipo_persona.current.value,
          cli_nombres: cli_nombres.current.value,
          cli_apellidos: cli_apellidos.current.value,
        } )
        .then( async function ( response ) {
          // handle success
          if ( response.data === "Registrado con éxito!" ) {
            toast.success( 'Cuenta creada con éxito ingresa ahora' );
            await setisOpenCrear( false );
          }
          if ( response.data === "El usuario ya existe" ) {
            toast.error( 'El usuario ya existe en nuestros sistemas, puedes cambiar la contraseña' );
          }

        } )
        .catch( function ( error ) {
          // handle error
          //  console.log(error);
          toast.error( " Ha ocurrido un error!" );
        } );
    } else {
      toast.error( "Todos los campos son obligatorios" );
    }

  };

  return (
    <>
      <Toaster />
      <div className="bg-gradient-info">
        <div className="container" style={ { height: "1300px" } }>
          {/* Outer Row */ }
          <div className="row justify-content-center">
            <div className="col-xl-10 col-lg-12 col-md-9">
              <div className="card o-hidden border-0 shadow-lg my-5">
                <div className="card-body p-0">
                  {/* Nested Row within Card Body */ }
                  <div className="row">
                    <div className="col-lg-6 d-none d-lg-block" style={ {
                      backgroundImage: `url(${ logo })`, backgroundRepeat: 'no-repeat',
                    } } />
                    <div className="col-lg-6">
                      <div className="p-5">
                        <div className="text-center">
                          <h1 className="h4 text-gray-900 mb-4">Bienvenido!</h1>
                        </div>
                        <form className="user">
                          <div className="form-group">
                            <input
                              type="email"
                              className="form-control form-control-user"
                              id="exampleInputEmail"
                              aria-describedby="emailHelp"
                              placeholder="Usuario"
                              ref={ user }
                              onKeyPress={ handleKeyPress }
                            />
                          </div>
                          <div className="form-group">
                            <input
                              type="password"
                              className="form-control form-control-user"
                              id="exampleInputPassword"
                              placeholder="Contraseña"
                              ref={ pass }
                              onKeyPress={ handleKeyPress }
                            />
                          </div>

                          <a
                            className="btn btn-primary btn-user btn-block"
                            onClick={ verificar }
                          >
                            Login
                          </a>
                          {/*     <hr /> */ }
                          {/*    <a className="btn btn-google btn-user btn-block">
                            <i className="fab fa-google fa-fw" /> Login with
                            Google
                          </a>
                          <a className="btn btn-facebook btn-user btn-block">
                            <i className="fab fa-facebook-f fa-fw" /> Login with
                            Facebook
                          </a> */}
                        </form>
                        <hr />
                        <div className="text-center">
                          <a className="small" onClick={ () => setisOpenOlvido( true ) }>Olvidó su contraseña?</a>
                        </div>
                        <div className="text-center">
                          <a className="small" onClick={ () => setisOpenCrear( true ) }>Crear cuenta nueva!</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal show={ isOpenOlvido } centered>
        <Modal.Body>
          <div className="card card-danger">
            <div className="card-header">
              <h3 className="card-title">Recuperar Contraseña</h3>
            </div>

            <div className="card-body">
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Cédula:</label>
                <input
                  ref={ cli_cedula }
                  type="text"
                  className="form-control"
                  placeholder="Ingrese la cédula registrada..."
                  autoFocus
                />
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Correo:</label>
                <input
                  ref={ cli_email }
                  type="text"
                  className="form-control"
                  placeholder="Ingrese su correo registrado..."
                />
              </div>
              <button className="btn btn-success" onClick={ recuperar }>
                Recuperar Contraseña
              </button>
              &nbsp;
              <button
                className="btn btn-primary"
                onClick={ () => setisOpenOlvido( false ) }
              >
                Cerrar
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={ isOpenCrear } centered>
        <Modal.Body>
          <div className="card card-danger">
            <div className="card-header">
              <h3 className="card-title">Crear cuenta</h3>
            </div>

            <div className="card-body">
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Tipo de documento:</label>
                <select className="form-control" ref={ cli_tipo_persona }>
                  <option value="CI">CI</option>
                  <option value="RUC">RUC</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Cédula:</label>
                <input
                  ref={ cli_cedula_reg }
                  type="text"
                  className="form-control"
                  placeholder="Ingrese cédula..."
                  autoFocus
                />
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Contraseña:</label>
                <input
                  ref={ cli_password }
                  type="password"
                  className="form-control"
                  placeholder="Ingrese contraseña..."
                />
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Email:</label>
                <input
                  ref={ cli_email_reg }
                  type="text"
                  className="form-control"
                  placeholder="Ingrese email..."
                />
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Dirección:</label>
                <input
                  ref={ cli_direccion }
                  type="text"
                  className="form-control"
                  placeholder="Ingrese dirección..."
                />
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Teléfono:</label>
                <input
                  ref={ cli_telefono }
                  type="text"
                  className="form-control"
                  placeholder="Ingrese teléfono..."
                />
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Nombres:</label>
                <input
                  ref={ cli_nombres }
                  type="text"
                  className="form-control"
                  placeholder="Ingrese Nombres..."
                />
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Apellidos:</label>
                <input
                  ref={ cli_apellidos }
                  type="text"
                  className="form-control"
                  placeholder="Ingrese Apellidos..."
                />
              </div>

              <button className="btn btn-success" onClick={ crearcuenta }>
                Crear cuenta
              </button>
              &nbsp;
              <button
                className="btn btn-primary"
                onClick={ () => setisOpenCrear( false ) }
              >
                Cerrar
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Login;
